module.exports = __webpack_public_path__ + "img/image-europa.222080ea.png";